import useReconcileEcocashOrders from "api/CommandCenterResource/useReconcileEcocashOrders";
import { useState } from "react";
import { AiOutlineLoading3Quarters, AiOutlineRight } from "react-icons/ai";

const ReconcileEcocashOrders = () => {
	const { mutateAsync, isLoading, data } = useReconcileEcocashOrders();
	const [hours, setHours] = useState(48);

	const runReconciliation = async () => {
		await mutateAsync(hours);
	};

	const result = data?.data;

	return (
		<div className="space-y-3">
			<div className="flex items-center gap-2">
				<label htmlFor="hours" className="text-sm text-gray-600">
					Look back:
				</label>
				<select
					id="hours"
					value={hours}
					onChange={(e) => setHours(Number(e.target.value))}
					className="text-sm border border-gray-300 rounded px-2 py-1"
				>
					<option value={6}>6 hours</option>
					<option value={12}>12 hours</option>
					<option value={24}>24 hours</option>
					<option value={48}>48 hours</option>
					<option value={72}>72 hours</option>
					<option value={168}>7 days</option>
				</select>
			</div>

			<div className="w-full px-2 py-2 rounded-lg bg-akgreen border-2 border-akgreener flex justify-between items-center text-white">
				<span className="text-base">Run Reconciliation</span>
				<button
					type="button"
					onClick={runReconciliation}
					disabled={isLoading}
					className="flex justify-between items-center px-2 py-2 bg-akgreenest rounded-lg gap-2 disabled:opacity-50"
				>
					Run
					{isLoading ? (
						<AiOutlineLoading3Quarters size={20} className="animate-spin" />
					) : (
						<AiOutlineRight size={20} />
					)}
				</button>
			</div>

			{result && (
				<div className="text-sm bg-gray-50 rounded p-3 space-y-1">
					<div className="font-medium text-gray-700">Results:</div>
					<div className="grid grid-cols-2 gap-2 text-gray-600">
						<span>Total checked:</span>
						<span className="font-medium">{result.total_checked}</span>
						<span>Recovered:</span>
						<span className="font-medium text-green-600">{result.recovered}</span>
						<span>Still failed:</span>
						<span className="font-medium text-gray-500">{result.still_failed}</span>
						<span>Errors:</span>
						<span className="font-medium text-red-600">{result.errors}</span>
					</div>

					{result.details && result.details.length > 0 && (
						<div className="mt-3 pt-3 border-t border-gray-200">
							<div className="font-medium text-gray-700 mb-2">Details:</div>
							<div className="max-h-40 overflow-y-auto space-y-1">
								{result.details.map((detail, index) => (
									<div
										key={index}
										className={`text-xs px-2 py-1 rounded ${
											detail.status === "recovered"
												? "bg-green-100 text-green-800"
												: detail.status === "error"
												? "bg-red-100 text-red-800"
												: "bg-gray-100 text-gray-600"
										}`}
									>
										{detail.order_number}:{" "}
										{detail.status === "recovered"
											? `Recovered → ${detail.new_status}`
											: detail.status === "error"
											? detail.error
											: `${detail.status} (${detail.ecocash_status || "N/A"})`}
									</div>
								))}
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default ReconcileEcocashOrders;
